import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import UserContext from '../../../../../common/utils/getContext';
import { useWindowDimensions } from '../../../../../common/utils/windowDimensions';
import CircleLoader from '../../../../plug/CircleLoader';
import css from './OpenSwitcher.module.scss';
import classnames from 'classnames';

const OpenSwitcher = ({
    setGridData,
    viewData,
    variant,
    afterOpenSwitherClick,
    setActiveTr,
    openSwitcher,
    rowData,
    lineOffset,
    levelOffset,
    loadingStructure = false,
    setLoadingStructure = () => {}
}) => {
    const level = useMemo(() => rowData.depth - levelOffset, [levelOffset, rowData?.depth]);
    const { userToken, setAlertData, lang, display_country } = useContext(UserContext);
    const [checkUser, setCheckUser] = useState(null);
    const firstDefaultOpened = useRef(false);
    const canPress = useRef(true);
    const mobile = useWindowDimensions() < 768;

    const getSubData = useMemo(() => {
        if (!(openSwitcher?.handlers && Object.keys(openSwitcher.handlers).length)) return {};
        return Object.keys(openSwitcher.handlers).reduce((accum, handlerName) => {
            accum[handlerName] = (argRowData, argViewData) => {
                const row_data =
                    argRowData && typeof argRowData === 'object' && 'currentTarget' in argRowData ? rowData : argRowData;
                return openSwitcher.handlers[handlerName](
                    row_data ? row_data : rowData,
                    setAlertData,
                    setGridData,
                    afterOpenSwitherClick,
                    userToken,
                    setActiveTr,
                    argViewData ? argViewData : viewData,
                    variant,
                    canPress,
                    lang,
                    false,
                    false,
                    display_country
                );
            };
            return accum;
        }, {});
    }, [
        openSwitcher?.handlers,
        rowData,
        setAlertData,
        setGridData,
        afterOpenSwitherClick,
        userToken,
        setActiveTr,
        viewData,
        variant,
        lang,
        display_country
    ]);

    useEffect(() => {
        const condVariant = variant === 1 || variant === 2;
        if (openSwitcher?.defaultOpened?.length && !firstDefaultOpened?.current && condVariant) {
            if (
                openSwitcher?.defaultOpened?.find((item) => item?.id === rowData?.id) &&
                getSubData?.onClick?.constructor === Function
            ) {
                getSubData?.onClick();
                firstDefaultOpened.current = true;
            }
        }
    }, [openSwitcher?.defaultOpened, getSubData, rowData?.id, variant]);

    useEffect(() => {
        const condVariant = variant === 1 || variant === 2;
        if (
            firstDefaultOpened?.current &&
            condVariant &&
            viewData?.data?.length &&
            openSwitcher?.forceOpen?.data?.length &&
            openSwitcher?.forceOpen?.data[0]?.id === viewData?.data[0]?.id
        ) {
            if (getSubData?.onClick?.constructor === Function) {
                getSubData?.onClick(viewData?.data[0], viewData);
                openSwitcher?.setForceOpen(false);
            }
        }
    }, [openSwitcher?.forceOpen, getSubData, variant, openSwitcher.setForceOpen, openSwitcher, viewData]);

    useEffect(() => {
        if (variant !== 3) {
            firstDefaultOpened.current = false;
        }
    }, [variant]);

    // для коректної висоти лінії
    const heightLine = useMemo(() => {
        const username = rowData?.username?.username;
        if (rowData?.sponsor && rowData?.sponsor?.username) {
            const sponsorUsername = rowData?.sponsor?.username;
            const sponsorIndexInArray = viewData?.data?.findIndex((user) => user?.username?.username === sponsorUsername);
            const userIndexInArray = viewData?.data?.findIndex((user) => user?.username?.username === username);
            if (userIndexInArray - sponsorIndexInArray === 1) {
                return 66;
            }
        }
        return 78;
    }, [viewData, rowData]);

    const innerStyles = {
        fullScreenLineMargin: { marginLeft: '7px' },
        fullScreenBottomOffset: { bottom: '50%' },
        leftOffset: { left: `${level * (mobile ? 44 : 44) - 24}px` },
        heightLine: { height: `${heightLine * lineOffset}px` }
    };

    return (
        <React.Fragment>
            {rowData.has_children ? (
                <div className={classnames(css.td__depthWrap)} {...getSubData}>
                    {loadingStructure && checkUser === rowData?.username ? (
                        <div className={css.switcherLoader}>
                            <CircleLoader />
                        </div>
                    ) : !!rowData.has_children ? (
                        <p
                            onClick={() => {
                                setCheckUser(rowData?.username);
                                setTimeout(() => {
                                    setCheckUser(null);
                                }, 1000);
                                setLoadingStructure(true);
                            }}
                            className={css.td__depth}
                        >
                            {rowData.isOpen ? '–' : '+'}
                        </p>
                    ) : (
                        <div className={css.divShowMenu}>
                            <p className={css.cursorPointer}> {rowData.isOpen ? '–' : '+'} </p>
                        </div>
                    )}
                </div>
            ) : (
                <div className={classnames(css.stubSwitcher)} />
            )}
            <React.Fragment>
                {!!level && variant !== 2 && (
                    <React.Fragment>
                        <div
                            style={{
                                ...innerStyles.fullScreenLineMargin,
                                ...innerStyles.leftOffset
                            }}
                            className={classnames(css.horizontLine, css.fullScreenBottomOffset, css.horizontLineWeb)}
                        />
                        <div
                            style={{
                                ...innerStyles.fullScreenLineMargin,
                                ...innerStyles.leftOffset,
                                ...innerStyles.heightLine
                            }}
                            className={classnames(css.verticalLine, css.fullScreenBottomOffset, css.verticalLineWeb)}
                        />
                    </React.Fragment>
                )}
            </React.Fragment>
        </React.Fragment>
    );
};
export default OpenSwitcher;
